module.exports = __webpack_public_path__ + "static/9d2d1f9321f743e1c6e1f79597d018709b3a8295659e7c92bbe5972c1d9671e1-df72c45c147951e42328720861a1719c.png";